<template>
    <div class="reports">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">
                    <inertia-link :href="'/backoffice/reports'" class="name">
                        <v-icon color="#921E61" class="mb-1">mdi-arrow-left-circle</v-icon>
                        {{ $page.props.lang.back || "Reports" }}
                    </inertia-link>
                / {{ $page.props.lang.courses || "Courses" }}</h2>
            </div>
        </div>
        <!-- <div class="table-header">
            <div class="pickers">
                <div class="field-group">
                    <p class="custom-label">{{ $page.props.lang.fromDate || 'From date' }}</p>
                    <v-menu
                    ref="menu"
                    v-model="fromDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="fromDate | formatDate"
                            append-icon="mdi-menu-down" outlined dense hide-details readonly v-bind="attrs" v-on="on" @click:append="fromDatePicker = true"></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="fromDate" :max="toDate"
                        :first-day-of-week="1" locale="en" no-title scrollable color="primary">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="fromDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn text color="primary" @click="fromDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <div class="field-group">
                    <p class="custom-label">{{ $page.props.lang.toDate || 'To date' }}</p>
                    <v-menu
                    ref="menu"
                    v-model="toDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="toDate | formatDate"
                            append-icon="mdi-menu-down" outlined dense hide-details readonly v-bind="attrs" v-on="on" @click:append="toDatePicker = true"></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="toDate" :min="fromDate"
                        :first-day-of-week="1" locale="en" no-title scrollable color="primary">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="toDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn text color="primary" @click="toDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <v-btn @click="filterByDates" color="primary" height="38">{{ $page.props.lang.apply || 'Apply' }}</v-btn>
            </div>
        </div> -->
        <div class="table-container with-color-avatar">
            <v-data-table
            :headers="coursesHeaders"
            :items="courses"
            :page.sync="tablePage"
            @page-count="tablePageCount = $event"
            item-key="item.id"
            mobile-breakpoint="0"
            hide-default-footer>
                <template v-slot:item.title="{ item }">
                    <div class="name-medium">
                        <v-avatar size="28">
                            <div class="color" :style="{ backgroundColor: item.color }"></div>
                        </v-avatar>
                        {{ item.title }}
                    </div>
                </template>
                <template v-slot:item.appointments="{ item }">
                    {{ item.appointments }}
                </template>
            </v-data-table>
        </div>
        <v-pagination v-model="tablePage" :length="tablePageCount" class="front-paginate"></v-pagination>
    </div>
</template>


<script>
import AppLayout from '@/js/Layouts/AppLayout'


export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "Courses Report"
        }
    },
    layout: AppLayout,
    props: {
        courses: Array,
        lang: Object
    },
    data(){
        return {
            date: moment().format('YYYY-MM-DD'),
            fromDatePicker: false,
            fromDate: moment().add(-30, 'days').format('YYYY-MM-DD'),
            toDatePicker: false,
            toDate: new Date().toISOString().substr(0, 10),
            coursesData: this.courses,
            coursesHeaders: [
                {text: this.lang.title_table || 'Title', value: 'title', align: 'start'},
                {text: this.lang.appointments || 'Appointments', value: 'appointments', align: 'center', sortable: false},
            ],
            tablePageCount: 0,
            tablePage: 1
        }
    },
    methods: {
        filterByDates() {
            this.$inertia.visit(
                '/backoffice/reports/courses?dateFrom=' + this.fromDate + '&dateTo=' + this.toDate, 
                {only:['courses']}
            )
        }
    }
}

</script>